export default "__VITE_ASSET__f8d25606__"